<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    width="60%"
    @close="close"
  >
    <el-form ref="form" label-width="100px" :model="form" :rules="rules">
      <el-form-item label="公寓" prop="apartmentId">
        <el-select @change="apartmentChange" v-model="form.apartmentId" placeholder="请选择" :disabled="title == '修改房型'">
          <el-option
            v-for="item in apartments"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="房型名称" prop="title">
        <el-input v-model="form.title" class="input-width" />
      </el-form-item>
      <el-form-item label="标题颜色">
        <el-color-picker
          v-model="form.titleColor"
          size="medium"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>
      <el-form-item label="颜色部分文字">
        <el-input v-model.trim="form.titleColorText" class="input-width" />
      </el-form-item>
      <el-form-item label="租赁模式" prop="mode">
        <el-radio v-model="form.mode" :label="1">整租</el-radio>
        <el-radio v-model="form.mode" :label="2">合租</el-radio>
      </el-form-item>
      <el-form-item label="标签" prop="tag">
        <el-select
          v-model="form.tag"
          multiple
          allow-create
          filterable
          default-first-option
          placeholder="请选择或填写标签"
          style="width:50%"
        >
          <el-option
            v-for="item in apartmentTags"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="朝向" prop="frontage">
        <el-input v-model="form.frontage" class="input-width" />
      </el-form-item>
      <el-form-item label="面积" prop="area">
        <el-input v-model="form.area" class="input-width" />
      </el-form-item>
      <el-form-item
        :label="index == 0 ? '价格' : ''"
        v-for="(item, index) of form.priceList"
        :key="index"
      >
        <el-col :span="10">
          <el-form-item
            :ref="index + 'lease'"
            :prop="'priceList.' + index + '.lease'"
            :rules="item.leaseRules"
          >
            <el-input v-model="item.lease" placeholder="请输入租期">
              <template v-slot:append>个{{period}}</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" style="margin-left: 20px">
          <el-form-item
            :ref="index + 'price'"
            :prop="'priceList.' + index + '.price'"
            :rules="item.priceRules"
          >
            <el-input v-model.number="item.price" placeholder="请输入价格">
              <template v-slot:append>每{{period}}</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" style="margin-left: 20px">
          <el-form-item
            :ref="index + 'text'"
            :prop="'priceList.' + index + '.text'"
          >
            <el-input v-model="item.text" placeholder="请输入文本">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="addPrice"
            v-if="index == 0"
          >
            添加
          </el-button>
          <el-button
            style="margin-left: 20px"
            type="primary"
            v-if="index !== 0"
            @click="delPrice(index)"
          >
            删除
          </el-button>
          <el-button
            style="margin-left: 20px"
            icon="el-icon-top"
            circle 
            v-if="index !== 0"
            @click="upPrice(index)"
          >
          </el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="入住时间">
        <el-row v-for="(item, index) in enterTimeList" :key="index">
          <el-col :span="12">
            <el-date-picker
              v-model="item.time"
              type="datetime"
              placeholder="请选择入住时间"
              value-format="x"
            />
          </el-col>
          <el-col :span="8">
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="addTime"
              v-if="index == 0"
            >
              添加
            </el-button>
            <el-button
              style="margin-left: 20px"
              type="primary"
              v-if="index !== 0"
              @click="delTime(index)"
            >
              删除
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
      <el-form-item label="公寓图片" prop="image">
        <ul class="el-upload-list el-upload-list--picture-card apartmentImgs">
          <draggable v-model="form.image"  tag="transition-group"  handle=".animated ">
            <transition-group>
            <li
              v-for="(item, index) in form.image"
              :key="item"
              class="el-upload-list__item is-success animated"
            >
              <img
                :src="item.url"
                alt=""
                class="el-upload-list__item-thumbnail"
              />
              <i class="el-icon-close"></i>
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemoveFileDetail(index)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </li>
            </transition-group>
          </draggable>
        </ul>
        <el-upload
          class="apartmentImg"
          ref="upload"
          :multiple="true"
          :auto-upload="false"
          :show-file-list="true"
          :action="QNUploadURL"
          :data="uploadToken"
          list-type="picture-card"
          :file-list="form.image"
          :http-request="uploadFile"
          :on-remove="image_remove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
          <el-button size="small" type="primary" @click="submitUpload">点击上传</el-button>
        建议尺寸比例 690:320
      </el-form-item>
      <el-form-item label="房屋视频" prop="videoUrl">
        <el-upload
          accept=".mp4,.m3u8"
          :action="QNUploadURL"
          :data="uploadToken"
          :before-upload="beforeUpload"
          :file-list="form.videoUrl"
          :on-success="video_success"
          :on-remove="video_remove"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <template v-slot:tip ><div class="el-upload__tip">只能上传MP4/M3U8文件</div></template>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import  {VueDraggableNext }  from 'vue-draggable-next'
import axios from 'axios'
import {
  createRoom,
  updateRoom,
  findBuildingList,
} from '@/api/apartment'
import { getUploadToken } from '@/api/app'
import { apartmentTags } from '@/utils/const'
import { QNUploadURL, QNHost } from '@/config/net.config'
import store from 'store'

export default {
  name: 'RoomEdit',
  emits: ['fetch-data'],
  components: {
            draggable:VueDraggableNext
        },
  data() {
    return {
      period:'月',
      showEditImage:true,
      apartmentsList:[],
      apartmentTags,
      uploadToken: {},
      QNUploadURL,
      QNHost,
      form: {
        apartmentId: '',
        title: '',
        mode: 1,
        tag: [],
        area: '',
        priceList: [
          {
            lease: '',
            price: '',
            text:'',
            leaseRules: [
              { required: true, trigger: 'blur', message: '请输入租期' },
            ],
            priceRules: [
              { required: true, trigger: 'blur', message: '请输入价格' },
            ],
          },
        ],
        frontage: '',
        titleColor: '#000',
        titleColorText: '',
        videoUrl: [],
        enterTimeList: [],
        image: [],
        apartments: [],
        enterTime: '',
        roomId: '',
        order: 0,
      },
      enterTimeList: [{ time: '' }],
      rules: {
        apartmentId: [
          { required: true, message: '请选择公寓' },
          {
            validator: (rule, value, callback) => {
              if (!this.form.apartmentId) {
                callback(new Error('请选择公寓'))
              } else {
                callback()
              }
            },
          },
        ],
        title: [
          { required: true, trigger: 'blur', message: '请输入房型名称' },
        ],
        tag: [{ required: true, trigger: 'blur', message: '请输入标签' }],
        area: [{ required: true, trigger: 'blur', message: '请输入面积' }],
        enterTime: [
          { required: true, trigger: 'blur', message: '请选择入住时间' },
        ],
      },
      title: '',
      dialogFormVisible: false,
      predefineColors: [
        '#333',
        '#ff5b45'
      ]
    }
  },
  mounted() {
    this.getBuildings()
  },
  methods: {
    async getBuildings() {
      const ret = await findBuildingList({
        page: 1,
        size: 1000,
      })
      this.apartments = ret.list.map((e) => ({
        label: e.title,
        value: e.apartmentId,
      }))
      this.apartmentsList = ret.list
      // console.log('this apartments', this.apartments)
    },
    apartmentChange(e){
      if(this.apartmentsList.find(i=>{
        return i.apartmentId==e
      }).basic&&this.apartmentsList.find(i=>{
        return i.apartmentId==e
      }).basic.period==1){
        this.period='周'
      }else{
        this.period='月'
      }
    },
    // 设置价格
    addPrice() {
      this.form.priceList.push({
        lease: '',
        price: '',
        leaseRules: [
          { required: true, trigger: 'blur', message: '请输入租期' },
        ],
        priceRules: [
          { required: true, trigger: 'blur', message: '请输入价格' },
        ],
      })
    },
    delPrice(index) {
      this.form.priceList.splice(index, 1)
    },
    upPrice(index) {
        this.form.priceList[index]=this.form.priceList.splice(index-1, 1,this.form.priceList[index])[0]
    },
    // 添加入住时间
    addTime() {
      this.enterTimeList.push({ time: '' })
    },
    delTime(index) {
      this.enterTimeList.splice(index, 1)
    },
    // 选择公寓
    buildingSelect(item) {
      console.log(item)
      this.form.title = item.value
      this.form.apartmentId = item.apartmentId
    },
    async buildingSearchAsync(keyword, cb) {
      const ret = await findBuildingList({
        keyword,
        page: 1,
        size: 1000,
      })
      cb(
        ret.list.map((e) => ({
          value: e.title,
          apartmentId: e.apartmentId,
        }))
      )
    },
    beforeUpload(file) {
      const isMP4 = file.type === 'video/mp4';
      const isM3U8 = file.type === 'video/m3u8';

      if (!isMP4 && !isM3U8) {
        this.$message.error('上传视频只能是 MP4 或 M3U8 格式!');
      }

      const result = isMP4 || isM3U8;
      return result;
    },
    video_remove(file, fileList) {
      this.form.videoUrl = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    video_success(res, file) {
      if (!res.hash) {
        this.$message.error('视频上传失败')
        return
      }
      this.form.videoUrl.push({
        name: file.name,
        url: `${QNHost}/${res.hash}`
      })
    },
    image_remove(file, fileList) {
        this.form.image = fileList.map((e) => ({
          name: e.name,
          url: e.url,
        }))
      },
      handleRemoveFileDetail(index) {
        this.form.image.splice(index, 1)
      },
      async uploadFile(file) {
        console.log(file,file)
        this.formData.set('file', file.file)
        const { data: res } = await axios.post(
          this.QNUploadURL,
          this.formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        )
        if (res.hash) {
          this.$message.success('发布成功！')
          this.form.image.push({
            name: file.file.name,
            url: QNHost + '/' + res.hash,
          })
          console.log(this.form.image, ' this.form.image')
        } else {
          return this.$message.error('发布失败！')
        }
      },
      // 点击按钮触发
      async submitUpload() {
        this.formData = new FormData()
        // this.formData.append("content", this.blogData.content);
        this.formData.append('token', this.uploadToken.token)
        this.$refs.upload.submit()
        this.showEditImage=false
      },
    async showEdit(row,type) {
      console.log(row);
      if (type) {
        this.title = type=='add'?'新增房型':'修改房型'
        const data = Object.assign(this.form, {
          ...row.basic,
          apartmentId: row.apartmentId,
          title: row.title,
          roomId: row.roomId,
          titleColor: row.basic && row.basic.titleColor || '#000',
        })
        this.enterTimeList = data.enterTimeList && data.enterTimeList.length
                            ? data.enterTimeList.map(i => ({ time: i }))
                            : [{ time: '' }]
        data.priceList.forEach((e) => {
          e['leaseRules'] = [
            { required: true, trigger: 'blur', message: '请输入租期' },
          ]
          e['priceRules'] = [
            { required: true, trigger: 'blur', message: '请输入价格' },
          ]
        })
         if(this.apartmentsList.find(i=>{
          return i.apartmentId==row.apartmentId
          })&&this.apartmentsList.find(i=>{
            return i.apartmentId==row.apartmentId
          }).basic.period==1){
            this.period='周'
          }else{
            this.period='月'
          }
      } else {
        this.title = '新增房型'
        this.enterTimeList = [{ time: '' }]
      }
      
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    close() {
      
      store.remove("roomData");
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        const roomId = this.form.roomId
        const data = Object.assign(this.form, {
          enterTimeList: this.enterTimeList.filter(i => !!i.time).map(i => i.time)
        },{period:this.period=='周'?1:0} )
        console.log(this.period=='周',data,'data');
        data.priceList.forEach((e) => {
          delete e['leaseRules']
          delete e['priceRules']
        })
        if (data.enterTimeList.length <= 0) {
          this.$message.warning('请填写入住时间')
          return
        }
        if (data.image.length > 0&&data.image.find(e=>e.url.includes('blob'))) {
          this.$message.warning('图片上传异常，提交失败')
          return
        }
        if (valid) {
          await (roomId ? updateRoom(data) : createRoom(data))
          this.$baseMessage(
            roomId ? '修改房型成功' : '新增房型成功',
            'success',
            false,
            'vab-hey-message-success'
          )
          this.$emit('fetch-data')
          this.close()
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .input-width {
    width: 50%;
  }
</style>
<style lang="scss">
  .el-color-picker__trigger {
    span + span {
      margin-left: 0!important;
    }
  }
  .el-color-dropdown {
    width: 324px!important;
  }
  .apartmentImgs .el-upload-list__item {
    width: 60px;
    height: 60px;
  }
  .apartmentImgs .el-upload-list__item-thumbnail {
    width: 60px;
  }
</style>